import React, { useContext } from 'react';
import { css } from '@emotion/react';
import { CircularProgress, TextField } from '@material-ui/core';
import { GreyBody, PrimaryButton, SectionSubtitle } from '@/styles/blocks';
import ExternalIdentifierStore, { ExternalIdentifierContext } from './store';

const ExternalIdentifiersTab = () => {
    const { state, callbacks } = useContext(ExternalIdentifierContext);
    const { rows, loading, busy, canSave, unavailable } = state;

    if (loading && !rows.length) return <CircularProgress size={18} />;
    if (unavailable) return <GreyBody>No identifiers configured for your organization.</GreyBody>;

    return (
        <div>
            {rows.map((row) => (
                <div
                    key={row.key}
                    css={css`
                        margin-bottom: 1.5rem;
                    `}
                >
                    <SectionSubtitle
                        css={css`
                            display: block;
                            margin-bottom: 0.5rem;
                        `}
                    >
                        {row.label}
                    </SectionSubtitle>
                    {row.description && (
                        <GreyBody
                            css={css`
                                display: block;
                                margin-bottom: 1rem;
                            `}
                        >
                            {row.description}
                        </GreyBody>
                    )}
                    <TextField
                        fullWidth
                        variant="outlined"
                        label={row.label}
                        value={row.value}
                        onChange={(e) => callbacks.onChange(row.key, e.target.value)}
                        disabled={loading || busy}
                    />
                </div>
            ))}
            <div>
                <PrimaryButton loading={busy} disabled={loading || !canSave} onClick={callbacks.save}>
                    Save
                </PrimaryButton>
            </div>
        </div>
    );
};

// Tab contract is ({ clientId }); the store is mounted here so the tab stays display-only.
const ExternalIdentifiers = ({ clientId }) => (
    <ExternalIdentifierStore clientId={clientId}>
        <ExternalIdentifiersTab />
    </ExternalIdentifierStore>
);

export default ExternalIdentifiers;
